import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// When the backend reports that the account's access period has ended (or not
// started), notify the app so it can return the user to the login screen.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const d = err.response?.data?.detail;
    const url = err.config?.url || "";
    if (err.response?.status === 403 && d && ["account_expired", "account_not_started"].includes(d.code) && !url.includes("/auth/login")) {
      window.dispatchEvent(new CustomEvent("kb:access-denied", { detail: d.msg }));
    }
    return Promise.reject(err);
  },
);

export function apiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
